function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 16,
  height: 16,
  rx: 1,
  stroke: "#A0AFBE",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 17.326a1 1 0 002 0h-2zm2-8.652a1 1 0 10-2 0h2zM17.326 14a1 1 0 100-2v2zm-8.652-2a1 1 0 100 2v-2zM14 17.326V8.674h-2v8.652h2zM17.326 12H8.674v2h8.652v-2z",
  fill: "#A0AFBE"
});
function SvgAddGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgAddGray;